enum Actions {
  SAVE_LEAD = 'saveLead',
}

enum Mutations {
  SET_CONTACT_ERROR = 'setContactError',
}

export { Actions, Mutations }
